import { simbaStyled } from '@naf-simba/theme';

export const ScrollAnchor = simbaStyled('div')(() => ({
  scrollMarginTop: '150px',
}));

export const CompetitionWrapper = simbaStyled('div')(() => ({
  p: {
    margin: '0 !important',
  },
}));

export const EndDateText = simbaStyled('div')(({ theme }) => ({
  marginTop: theme.spacing('m'),
}));

export const SubmitButtonWrapper = simbaStyled('div')(({ theme }) => ({
  marginTop: theme.spacing('ml'),
  width: '100%',

  button: {
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: 'fit-content',
      minWidth: '127px',
    },
  },
}));

export const TermsContainer = simbaStyled<'div', { $style?: 'spruce' | 'white' }>('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing('l'),
  marginBottom: theme.spacing('xl'),
}));

export const SpruceCheckboxWrapper = simbaStyled<'div', { $isSpruceMode: boolean }>('div')(
  ({ theme, $isSpruceMode }) => ({
    ...($isSpruceMode && {
      p: {
        color: theme.palette.simba.colors.common.white,
      },
    }),
  }),
);
